<mat-tab-group>
  <mat-tab label="Vulnerability Finder">
    <globalProjectControlItems-component></globalProjectControlItems-component>
  </mat-tab>
  <mat-tab label="CVE">
    <div class='poam-component' style='height: 100%'>
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
        <div>
          <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px">CVE</h2>
        </div>

        <div style="display: flex; flex-direction: row; margin-top: 6px;margin-bottom: 10px;align-items:center;">
          @if (isMaster) {
            <button type="button"
                    (click)="updateCve()"
                    pButton
                    class="risksponge-button">Update</button>
          }
        </div>
      </div>
      <p-table [value]="cve"
               [style]="{'margin-top':'10px', 'white-space':'nowrap'}" sortField="deviceId"
               #devicesTable>

        <ng-template pTemplate="header">
          <tr>
            <th>CVE ID</th>
            <th>Manufacturer</th>
            <th>Model</th>
            <th>Description</th>
            <th>Date Announced</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
          <tr>
            <td><a target="_blank" [href]="'https://www.cve.org/CVERecord?id=' + item.cveId">{{ item.cveId }}</a></td>
            <td>{{ item.manufacturer }}</td>
            <td style="white-space: wrap;">{{ item.model }}</td>
            <td style="white-space: wrap;">{{ item.description }}</td>
            <td>{{ item.dateAnnounced | date : 'shortDate' }}</td>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </mat-tab>
</mat-tab-group>
